import React from 'react';

interface GrowthChartProps {
  isVisible: boolean;
}

const GrowthChart: React.FC<GrowthChartProps> = ({ isVisible }) => {
  return (
    <div className="w-full flex justify-center mt-6 md:mt-8">
      <svg
        className="w-full max-w-2xl h-32 md:h-40 lg:h-48"
        viewBox="0 0 400 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet">
        {/* Curva con alti e bassi crescenti fino al massimo assoluto */}
        <path
          d="M 10,85
             C 50,75 70,60 90,50
             C 110,40 120,55 140,58
             C 160,61 180,50 200,40
             C 220,30 230,48 250,52
             C 270,56 290,28 320,8
             C 350,-8 380,-12 390,-15"
          stroke="#E63946"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          className={`growth-line ${isVisible ? 'animate' : ''}`}
          style={{
            strokeDasharray: 630,
            strokeDashoffset: isVisible ? 0 : 630,
          }}
        />

        {/* Stile inline per l'animazione */}
        <style>{`
          .growth-line {
            transition: stroke-dashoffset 2.5s cubic-bezier(0.4, 0, 0.2, 1) 1s;
          }

          @media (prefers-reduced-motion: reduce) {
            .growth-line {
              transition: none;
              stroke-dashoffset: 0 !important;
            }
          }
        `}</style>
      </svg>
    </div>
  );
};

export default GrowthChart;
